import { SelectOption } from 'Types/Option'
import { trimPrototcolAndWww } from 'Utils/routes'
import { theme } from '@clickcease/cc-client-components-lib'

export const {
  colors: {
    neutral: { value: neutralColor },
    primaryColor: { value: primaryColor },
  },
} = theme

export const PLAN_OPTIONS = {
  bundle: 'bundle',
  paidMarketing: 'paidMarketing',
  botZapping: 'botZapping',
}

export const MIN_DOMAINS_LEFT = 2
export const PRODUCTS_HIDE_SELECT_ALL = 1
export const MAX_DOMAINS = 30
export const SORT_COLUMNS = {
  DOMAINS: 'add_new_multiple_domains_modal.columns.domains',
  PRODUCTS: 'add_new_multiple_domains_modal.columns.product',
}

export const createOption = (label: string): SelectOption[] => [
  {
    label,
    value: trimPrototcolAndWww(label),
  },
]

export function combineAndRemoveDuplicates(
  arr1: SelectOption[],
  arr2: SelectOption[]
): SelectOption[] {
  const combined = arr1.concat(arr2)
  const unique = combined.reduce<SelectOption[]>((acc, curr) => {
    const exists = acc.some((option) => option.value === curr.value)
    if (!exists) acc.push(curr)
    return acc
  }, [])
  return unique
}
